(() => {
  const page = document.querySelector('[data-fh-buzz-page]');
  if (!page) return;
  const select = page.querySelector('[data-fh-buzz-curator]');
  const buttons = [...page.querySelectorAll('[data-fh-buzz-filter]')];
  const results = page.querySelector('[data-fh-buzz-results]');
  const status = page.querySelector('[data-fh-buzz-status]');
  const params = new URLSearchParams(location.search);
  let reaction = params.get('reaction') || '';
  if (!buttons.some(button => button.dataset.fhBuzzFilter === reaction)) reaction = '';
  select.value = params.get('curator') || '';
  if (!select.value) select.value = '';
  let loading = true;
  let failed = false;
  const update = (saveUrl = false) => {
    let count = 0;
    results.querySelectorAll('[data-product]').forEach(card => {
      const show = (!reaction || card.dataset.reaction === reaction) && (!select.value || card.dataset.curator === select.value);
      card.hidden = !show;
      if (show) count++;
    });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.fhBuzzFilter === reaction)));
    status.textContent = loading ? status.dataset.loading : failed ? status.dataset.error : count === 1 ? status.dataset.one : count ? status.dataset.count.replace('__COUNT__', count) : status.dataset.empty;
    if (saveUrl) {
      const url = new URL(location.href);
      select.value ? url.searchParams.set('curator', select.value) : url.searchParams.delete('curator');
      reaction ? url.searchParams.set('reaction', reaction) : url.searchParams.delete('reaction');
      url.searchParams.delete('page');
      history.replaceState(null, '', url);
    }
  };
  select.addEventListener('change', () => update(true));
  buttons.forEach(button => button.addEventListener('click', () => { reaction = button.dataset.fhBuzzFilter; update(true); }));
  update();
  (async () => {
    let next = results.querySelector('[data-fh-buzz-next]')?.getAttribute('href');
    const seen = new Set();
    const products = new Set([...results.querySelectorAll('[data-product]')].map(card => card.dataset.product));
    try {
      while (next && !seen.has(next)) {
        seen.add(next);
        const url = new URL(next, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid next page');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Could not load picks');
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextResults = documentPage.querySelector('[data-fh-buzz-results]');
        if (!nextResults) throw new Error('Missing picks page');
        nextResults.querySelectorAll('[data-product]').forEach(card => {
          if (!products.has(card.dataset.product)) { products.add(card.dataset.product); results.appendChild(card); }
        });
        next = nextResults.querySelector('[data-fh-buzz-next]')?.getAttribute('href');
        update();
      }
      results.querySelectorAll('[data-fh-buzz-next]').forEach(link => link.remove());
    } catch { failed = true; }
    loading = false;
    update();
  })();
})();
